module.exports = __webpack_public_path__ + "img/logoPDF.56cf2726.png";